import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    receivedVoucher_kindergartenVoucherQueueId: 'Номер ваучера',
    receivedVoucher_receiveDate: 'Дата и время',
    receivedVoucher_childIin: 'ИИН ребенка',
    receivedVoucher_childFullName: 'ФИО ребенка',
    receivedVoucher_queuedType: 'Тип очереди',
    receivedVoucher_arriveDeadline: 'Срок ваучера',
    receivedVoucher_status: 'Статус',
    receivedVoucher_bulletinId: 'Номер бюллетени',
    receivedVoucher_serviceProviderLocation: 'Населенный пункт',
    receivedVoucher_serviceProviderBin: 'БИН',
    receivedVoucher_userCategory: 'Возрастная группа',

    receivedVoucher_modalTitle: 'Ваучер',
    receivedVoucherPage_title: 'Полученные ваучеры',
    receivedVoucher_errorLoadTable: 'Не удалось загрузить ваучеры'
  },
  kk: {
    receivedVoucher_kindergartenVoucherQueueId: 'Ваучер нөмірі',
    receivedVoucher_receiveDate: 'Күні, уақыты',
    receivedVoucher_childIin: 'Бала ЖСН-і',
    receivedVoucher_childFullName: 'Баланың аты-жөні',
    receivedVoucher_queuedType: 'Кезек түрі',
    receivedVoucher_arriveDeadline: 'Ваучер мерзімі',
    receivedVoucher_status: 'Мәртебесі',
    receivedVoucher_bulletinId: 'Бюллетень нөмірі',
    receivedVoucher_serviceProviderLocation: 'Аймақ',
    receivedVoucher_serviceProviderBin: 'БИН',
    receivedVoucher_userCategory: 'Жас тобы',

    receivedVoucher_modalTitle: 'Ваучер',
    receivedVoucherPage_title: 'Алынған ваучерлер',
    receivedVoucher_errorLoadTable: 'Ваучерлерді жүктеу мүмкін болмады'
  }
});
